import { globalVars } from "../global/GlobalVars.js";
import * as navigation from "../utils/navigation.js";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

//========================================================================
// Konfiguration der api-Schnittstelle
const loginUrl =
  window.location.port === "3000"
    ? `http://${window.location.hostname}:${globalVars.httpPort}/auth/`
    : `/api/auth/`;

//========================================================================
// Benutzerdaten überprüfen
const getAuthentication = () => {
  try {
    const token = localStorage.getItem("token");
    const decodedToken = jwtDecode(token);
    const auth = decodedToken.userData;
    // console.log(auth);
    globalVars.setAuth(auth);
    return true;
  } catch (error) {
    // console.error("Invalid token", error);
    return false;
  }
};

//========================================================================
// Überprüfen, ob Login notwendig
const checkIfLogin = async () => {
  let token;
  let decodedToken;
  let auth = {};
  auth.loggedIn = false;
  try {
    token = localStorage.getItem("token");
    decodedToken = jwtDecode(token);
    auth = decodedToken.userData;
    globalVars.setAuth(auth);
    // console.log("auth: ", auth);
  } catch (err) {
    // console.log(err);
  }

  if (!auth.loggedIn) {
    getUsers();
    try {
      const response = await axios.post(loginUrl + "checkIfLogin");
      localStorage.setItem("token", response.data.token);
      let token = localStorage.getItem("token");
      let decodedToken = jwtDecode(token);
      let auth = decodedToken.userData;
      globalVars.setAuth(auth);
    } catch (error) {
      // console.error("check if Login failed", error);
    }

    if (globalVars.auth.loggedIn) {
      if (!globalVars.mobile) {
        navigation.changePage("home");
      } else {
        navigation.changePage("homeMobile");
      }
      globalVars.setPageHistory([]);
    }
  }
};

//========================================================================
// Liste aller Benutzer
const getUsers = async () => {
  try {
    const response = await axios.post(loginUrl + "getUsers");
    globalVars.setUsers(response.data.registeredUsers);
    // console.log(globalVars.users);
  } catch (error) {
    // console.error("get Users failed", error);
  }
};

//========================================================================
// Liste aller Benutzergruppen
const getGroups = async () => {
  try {
    const response = await axios.post(loginUrl + "getGroups");
    return response.data.registeredGroups;
  } catch (error) {
    // console.error("get Groups failed", error);
    return [];
  }
};

//========================================================================
// Benutzer hinzufügen
const register = async (
  e,
  username,
  group,
  password,
  expiration,
  setFeedbackMessage,
) => {
  e.preventDefault();
  try {
    let authorization = globalVars.auth.createUsers;
    const response = await axios.post(loginUrl + "register", {
      username,
      group,
      password,
      expiration,
      authorization,
    });
    setFeedbackMessage("User successfully registered");
    return response.data;
  } catch (error) {
    // console.error("Registration failed", error);
    setFeedbackMessage("Registration failed");
    return null;
  }
};

//========================================================================
// Einloggen
const login = async (e, username, password, setFeedbackMessage) => {
  e.preventDefault();
  try {
    const response = await axios.post(loginUrl + "login", {
      username,
      password,
    });
    localStorage.setItem("token", response.data.token);
    setFeedbackMessage("Login successful");
    getAuthentication();
    globalVars.setPageHistory([]);
    return true; // Erfolg
  } catch (error) {
    // console.error("Login error", error);
    setFeedbackMessage("Login error");
    return false; // Misserfolg
  }
};
//========================================================================
// Ausloggen
const logout = () => {
  try {
    localStorage.removeItem("token");
    globalVars.setAuth({});
    window.location.reload();
  } catch (err) {
    // console.log(err);
  }
};

//========================================================================
// Passwort ändern
const changePassword = async (
  e,
  username,
  oldPassword,
  newPassword,
  confPassword,
  setFeedbackMessage,
) => {
  e.preventDefault();
  let authorization = globalVars.auth.changeUsers;
  try {
    const response = await axios.post(loginUrl + "changePassword", {
      username,
      oldPassword,
      newPassword,
      confPassword,
      authorization,
    });
    setFeedbackMessage("Password changed successfully");
  } catch (error) {
    // console.error("Passwort ändern fehlgeschlagen", error);
    setFeedbackMessage("Error changing the password");
  }
};

//========================================================================
// Benutzer löschen
const deleteUser = async (e, username, setFeedbackMessage) => {
  e.preventDefault();
  let authorization = globalVars.auth.changeUsers;
  try {
    const response = await axios.post(loginUrl + "deleteUser", {
      username,
      authorization,
    });
    setFeedbackMessage("Delete user successful");
  } catch (error) {
    // console.error("Delete user failed", error);
    setFeedbackMessage("Delete user failed");
    return null;
  }
};

//========================================================================
// Funktionen exportieren
export {
  checkIfLogin,
  getUsers,
  getGroups,
  register,
  login,
  logout,
  getAuthentication,
  changePassword,
  deleteUser,
};
